import { render, staticRenderFns } from "./coinlist.vue?vue&type=template&id=6a9ae772"
import script from "./coinlist.vue?vue&type=script&lang=js"
export * from "./coinlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports